import React from 'react';

import PropTypes from 'prop-types';

import { DropdownMenu } from '../../MenuTypes';
import MenuTitle from '../MenuTitle/MenuTitle';
import Events from '../events/AccountEvents';
import AccountMenuContent from './AccountMenuContent/AccountMenuContent';

function DropdownAccountMenu(props) {
    const {
        isLoggedIn = false,
        userFirstName = '',
        onLogOut = () => undefined,
    } = props;

    const clickButton = () => {
        Events.clicked({
            action: 'expand_menu',
            label: 'account_modal',
            navType: 'nav_bar',
        });
    };

    return (
        <DropdownMenu
            onToggleMenu={clickButton}
            title={<MenuTitle
                isLoggedIn={isLoggedIn}
                userFirstName={userFirstName}
            />}
        >
            <AccountMenuContent
                isLoggedIn={isLoggedIn}
                onLogOut={onLogOut}
            />
        </DropdownMenu>
    );
}

DropdownAccountMenu.propTypes = {
    isLoggedIn: PropTypes.bool,
    onLogOut: PropTypes.func,
    userFirstName: PropTypes.string,
};

export default DropdownAccountMenu;
